module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-insurance-e9c4c29fe199c84e4708607ff6af0a72.jpg";